import { addMinutes } from 'date-fns/addMinutes'
import { isAfter } from 'date-fns/isAfter'
import { parseISO } from 'date-fns/parseISO'

import { DEFAULT_SPA_DURATION_MINUTES } from 'bl-utils/src/activityDuration'
import type { TimeSlot } from 'bl-flows-core/src/types'
import { formatDateInUTC } from 'bl-utils/src/formatting/formatDate'

const getTransportationDepartureSelectionStartTime = (
  timeSlots: TimeSlot[],
  entryDate: Date,
  lastActivityDate: string,
  lastActivityDuration: number,
  spaDuration: number
) => {
  if (!timeSlots || timeSlots.length === 0) {
    return ''
  }

  const entryDateStr = formatDateInUTC(entryDate, 'yyyy-MM-dd')

  // find latest time
  let latestTime
  if (lastActivityDate) {
    latestTime = addMinutes(
      new Date(lastActivityDate),
      lastActivityDuration || spaDuration
    )
  } else {
    latestTime = entryDate
  }

  const slotsAfterLatestTime = timeSlots.filter(slot =>
    isAfter(parseISO(`${entryDateStr}T${slot.time}:00Z`), latestTime)
  )

  return slotsAfterLatestTime.length > 0 ? slotsAfterLatestTime[0].time : ''
}
export const getAvailableDepartureSlots = ({
  timeSlots,
  entryDate,
  lastActivityDate,
  lastActivityDuration,
  spaDuration = DEFAULT_SPA_DURATION_MINUTES,
}: {
  timeSlots: TimeSlot[]
  entryDate: Date
  lastActivityDate?: string
  lastActivityDuration?: number
  spaDuration?: number
}) => {
  const startTime = getTransportationDepartureSelectionStartTime(
    timeSlots,
    entryDate,
    lastActivityDate,
    lastActivityDuration,
    spaDuration
  )

  const startIndex = timeSlots.findIndex(slot => slot.time === startTime)

  return timeSlots.slice(startIndex)
}
